import axios from 'axios';
import { ImageObjType, InventoryGetAllQuery, InventoryGetItemsQuery } from '../types';
import { containerValidator } from '../utils';

interface GetItemsParams {
  id: string;
  number?: string;
  take?: number;
  skip?: number;
  notLoading?: boolean;
}

type InventoryItem = InventoryGetItemsQuery['data'][number];

interface TransformedInventoryItem extends InventoryItem {
  label: string;
  id: string;
  isNew?: boolean;
  isWrong?: boolean;
}

class InventoryService {
  getAll = (props: any) => axios.get<InventoryGetAllQuery>('/inventories', props);

  getItems =
    ({ id, ...props }: GetItemsParams) =>
    async (): Promise<TransformedInventoryItem[]> => {
      if (!props.number) {
        return [];
      }

      const FAKE_ID = 'fakeID';
      const response = await axios.get<InventoryGetItemsQuery>(`/inventories/${id}/items`, {
        params: props,
      });

      const transformedItems: TransformedInventoryItem[] = response.data.data.map((item) => ({
        ...item,
        label: item.number,
        id: item.containerId || FAKE_ID,
      }));

      if (transformedItems.length === 0 && props.number) {
        const isValidContainer = containerValidator(props.number);
        const emptyItem: TransformedInventoryItem = {
          id: FAKE_ID,
          containerId: '',
          number: props.number,
          status: 'NOT_FOUND',
          unchecked: {
            type: '',
            block: '',
          },
          label: props.number,
          ...(isValidContainer ? { isNew: true } : { isWrong: true }),
        };

        return [emptyItem];
      }

      return transformedItems;
    };

  itemCheck = async ({ id, ...props }: any) =>
    axios.patch(`/inventories/${id}/item-check`, [props]).then((res) => res.data.data);

  uploadImages = (id: string, photos: ImageObjType[] = []) => {
    if (!photos.length) return true;

    const formData = new FormData();
    for (const i in photos.map((obj) => obj.file)) {
      formData.append(`images`, photos[i].file);
    }

    return axios.patch(`/inventories/${id}/item-upload-images`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  };

  itemUploadImages = async ({ id, photos = [] }: { id: string; photos: ImageObjType[] }) => {
    return this.uploadImages(
      id,
      photos.filter((obj) => obj.action === 'upload'),
    );
  };

  complete = async ({ id }: any) => axios.patch(`/inventories/${id}/complete-employee`);
}

export const inventoryService = new InventoryService();
